/* eslint-disable react/prop-types */
import React, { useEffect, useState } from 'react';
import { setAuthToken } from 'helpers/api';

const App = ({ children }) => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [preCallToken, setPreCallToken] = useState(localStorage.getItem("token") || null);

  
  // Handle PostMessage Authentication
  useEffect(() => {
    // Notify parent that webpack is ready
    window.parent.postMessage({ type: 'webpackOk' }, '*');

    // Event listener for received messages
    const handleMessage = (event) => {
      // IMPORTANT: Always verify the origin
      const allowedOrigins = [
        'http://localhost:3000',  // Parent window domain
        'https://app.qcall.ai'
      ];
      // Reject messages from unauthorized origins
      if (!allowedOrigins.includes(event.origin)) {
        console.warn('Received message from unauthorized origin:', event.origin);
        return;
      }

      // Check if the message is of the expected type
      if (event.data && event.data.type === 'AUTH_INIT') {
        // Validate and process the received data
        const { token, language, theme } = event.data.payload;
        if (token) {
          // Store token in localStorage and state
          localStorage.setItem('token', token);
          localStorage.setItem('language', language);
          localStorage.setItem('theme', theme);
          setAuthToken(token);
          setPreCallToken(token);
          setIsAuthenticated(true);
        } else {
          // Clear token and redirect
          localStorage.removeItem('token');
          window.location.href = "/admin/dashboard";
        }

        // Optional: Send acknowledgment back to parent
        if (event.source) {
          event.source.postMessage({
            type: 'AUTH_RECEIVED',
            status: 'success'
          }, event.origin);
        }
      }
    };

    // Add event listener
    window.addEventListener('message', handleMessage);

    // Cleanup listener on component unmount
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);
  useEffect(() => {
    if (preCallToken) {
      setAuthToken(preCallToken);
      setIsAuthenticated(true);
    }
  }, [preCallToken]);
  // Render children only if authenticated
  return isAuthenticated ? <>{children}</> : null;
};

export default App;